import { stringify as stringifyQs } from "qs";
import urljoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  TabActionDialog
} from "../types";

const ClusterSection = "/clusters/";

export const ClusterListPath = ClusterSection;

export enum ClusterListUrlFiltersEnum {
  status = "status",
  productType = "productType",
  query = "query"
}
export type ClusterListUrlFilters = Filters<ClusterListUrlFiltersEnum>;
export type ClusterListUrlDialog =
  | "assign-status"
  | "deactivate"
  | "delete"
  | TabActionDialog;
export type ClusterListUrlQueryParams = ActiveTab &
  BulkAction &
  ClusterListUrlFilters &
  Dialog<ClusterListUrlDialog> &
  Pagination;

export const clusterListUrl = (params?: ClusterListUrlQueryParams) =>
  ClusterSection + "?" + stringifyQs(params);

export const clusterAddPath = urljoin(ClusterSection, "add");
export const clusterAddUrl = () => clusterAddPath;
export const clusterPath = (id: string) => urljoin(ClusterSection, id);
export type ClusterUrlDialog = "delete";
export type ClusterUrlQueryParams = Dialog<ClusterUrlDialog>;
export const clusterUrl = (id: string, params?: ClusterUrlQueryParams) =>
  clusterPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
